import { LitElement, html, svg } from 'lit';

export class IconCalendar32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Kalender</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M29 5H3a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2ZM1 13h30M9 7V1M16 25v-7M18 25h-4M16 18l-2 1M23 7V1"></path></svg>`; }
}
if (!customElements.get('f-icon-calendar32', IconCalendar32)) {
  customElements.define('f-icon-calendar32', IconCalendar32);
}